interface ITitleContainerProps {
  children: React.ReactNode;
}

export const TitleContainer: React.FC<ITitleContainerProps> = ({
  children,
}) => {
  return (
    <span className="tw-flex tw-w-[-webkit-fill-available] tw-items-center tw-justify-center tw-truncate tw-text-center tw-grid-area-[title] desktop:tw-justify-start desktop:tw-text-left">
      {children}
    </span>
  );
};
